<template>
    <navBar ref="navBarRef"/>
    <router-view :checkLogout="checkLogout"></router-view>
    <Footer :clarityIdProps="clarityId" />
</template>
<script setup>
import navBar from "@/components/navBar.vue";
import Footer from "@/components/footer.vue";
import Swal from "sweetalert2";
import {onBeforeUnmount, onMounted, ref,onUpdated,inject} from "vue";
import userStatus from "@/utils/userStatus";
import _ from "lodash";
import {useRouter} from "vue-router";
import { v4 as uuidv4 } from 'uuid';
import { postApi } from "@/utils/callApi";
import apiConfig from "@/utils/apiConfig";

const checkLogout = ref(false);
const $cookies = inject('$cookies');
const navBarRef = ref();
const eventList = ["scroll", "click", "mousemove"
    , "keyup", "keypress", "touchstart"
    , "touchend", "touchcancel", "touchmove"];
const clarityId = ref('');
const isLogin = ref(JSON.parse(sessionStorage.getItem("isLogin")));
const alertFunc = (errorTxt, errorTitle, icon, thenCallback) =>{ //錯誤alert
    Swal.fire({
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: '確定',
        customClass: {
            container: "swal-S",
        },
        html: `<img src="${require('@/assets/' + icon + '.svg')}" alt="Error"><div><h3 class="alertTitle">${errorTitle}</h3><p>${errorTxt}</p></div>`,
    }).then(thenCallback);
};
const router = useRouter();//轉跳router
const uuid = () =>{
    let uuid = sessionStorage.getItem('sessionId');
    if (!uuid) {
        sessionStorage.setItem('sessionId', uuidv4());
    }
}
// const isSendClarity = () => {
//     let isSendClarity = sessionStorage.getItem('isSendClarity');
//     if (!isSendClarity) {
//         sessionStorage.setItem('isSendClarity', false);
//     }
// }
uuid();
// isSendClarity();

//clarity後續在加入
const sendClarity= _.throttle( () => {
    clarityId.value = $cookies.get('_clck').split('^')[0]
    let isSendClarity = JSON.parse(sessionStorage.getItem('isSendClarity'));
    let sessionId = sessionStorage.getItem('sessionId');
    if(window.fpc && window.clarity && sessionId && !isSendClarity){
        sessionStorage.setItem('isSendClarity', true);
        sessionStorage.setItem('fpcInfo', JSON.stringify({
            clarityId: clarityId.value,
            sessionId: sessionId,
            fpc: window.fpc
        }));
        utmSource();
    }
}, 1000 * 3)

// RND-172 訂單來源媒介 2025.01.10 HansHuang
const utmSource = () => {
    /*
    使用 regex 判斷字串含有 "utm_source=[any]&utm_medium=[any]" 存入 sessionStorage
    存入前，先判斷 sessionStorage 是否已存在，
    若存在則進行內容比對，若不同則更新
    若不存在則直接存入
    */
    let queryString = window.location.search;
    const regex = /utm_source=[^&]+&utm_medium=[^&]+|gclid=[^&]+/g;
    let matches = queryString.match(regex);
    if (matches) {
        const existingUtmParams = JSON.parse(sessionStorage.getItem('utmParams'));
        if (!arraysEqualIgnoreOrder(existingUtmParams, matches)) {
            sessionStorage.setItem('utmParams', JSON.stringify(matches));
            matches.forEach(newUtmParams => {
                let tagName, tagValue;
                if (newUtmParams.startsWith('gclid')) {
                    tagName = 'gclid';
                    tagValue = '';
                } else {
                    tagName = 'UTM';
                    tagValue = newUtmParams;
                }
                let fpcInfo = JSON.parse(sessionStorage.getItem('fpcInfo'));
                if (fpcInfo) {
                    postApi(apiConfig.clarityDomain + apiConfig.event, null, null, null, {
                        tagName: tagName,
                        tagValue: tagValue,
                        sessionId: fpcInfo.sessionId,
                        fpc: fpcInfo.fpc,
                        clarityId: fpcInfo.clarityId,
                        insuranceType: "EC",
                    });
                }
            });
        }
    }
};

const arraysEqualIgnoreOrder = (arr1, arr2) => {
    if (!Array.isArray(arr1) || !Array.isArray(arr2) || arr1.length !== arr2.length) {
        return false;
    }
    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();
    for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
            return false;
        }
    }
    return true;
};

const refreshToken = _.throttle(() =>{
    let jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
    if (jwtInfo) {
        if(process.env.VUE_APP_ENV === 'stage' || process.env.VUE_APP_ENV === 'prod'){
            userStatus.refreshToken(jwtInfo.appKey, function (jwtInfo) {
                if (!jwtInfo) {
                    alertFunc('您好，因網頁閒置已逾30分鐘，未進行任何操作，基於資訊安全的考量，請按下確認後回到首頁，謝謝！', '提醒', 'noticemark', ()=>{
                        checkLogout.value = true;
                        isLogin.value = false;
                        sessionStorage.setItem("isLogin", false);
                        router.push('/FY24_luckydraw').then(() => document.getElementById('login').scrollIntoView());
                    })
                }
            });
        }else{
            userStatus.refreshTokenForDev({
                account: jwtInfo.account,
                token: jwtInfo.refreshToken
            }, function (jwtInfo) {
                if (!jwtInfo) {
                    alertFunc('您好，因網頁閒置已逾30分鐘，未進行任何操作，基於資訊安全的考量，請按下確認後回到首頁，謝謝！', '提醒', 'noticemark', ()=>{
                        checkLogout.value = true;
                        isLogin.value = false;
                        sessionStorage.setItem("isLogin", false);
                        router.push('/FY24_luckydraw').then(() => document.getElementById('login').scrollIntoView());
                    })
                }
            });
        }
    }
},1000 * 60 * 4)

const logout = _.debounce(() =>{
    let jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
    if (jwtInfo) {
        // TODO: 開發時使用 上線需調整
        userStatus.logout(jwtInfo.appKey, function () {
            alertFunc('您好，因網頁閒置已逾30分鐘，未進行任何操作，基於資訊安全的考量，請按下確認後回到首頁，謝謝！', '提醒', 'noticemark', ()=>{
                checkLogout.value = true;
                isLogin.value = false;
                sessionStorage.setItem("isLogin", false);
                router.push('/FY24_luckydraw').then(() => document.getElementById('login').scrollIntoView());
            })
        });
    }
},1000*60*30 )

onMounted(()=>{
    sessionStorage.setItem('isSendClarity', false);
    eventList.forEach(event => {
        document.addEventListener(event, refreshToken);
    });
    eventList.forEach(event => {
        document.addEventListener(event, logout);
    });
    eventList.forEach(event => {
        document.addEventListener(event, sendClarity);
    });
});

onBeforeUnmount(()=>{
    eventList.forEach(event => {
        document.removeEventListener(event, refreshToken);
    });
    eventList.forEach(event => {
        document.removeEventListener(event, logout);
    });
    eventList.forEach(event => {
        document.removeEventListener(event, sendClarity);
    });
});

// onBeforeUpdate(()=>{
//     utmSource();
// });

onUpdated(()=>{
    // isSendClarity.value = false;
});
</script>
<style lang="scss">
@import "./assets/style/layout.scss";
</style>
